// Airport registry: meta data (hand-maintained) and generated geometry, loaded lazily per airport.
import type { AirportGeo, AirportMeta } from '../types';
import { Airport } from '../../sim/airport';

export interface AirportEntry { icao: string; name: string; available: boolean; load: () => Promise<{ meta: AirportMeta; geo: AirportGeo }> }

export const AIRPORTS: AirportEntry[] = [
  { icao: 'EDDW', name: 'Bremen', available: true, load: async () => ({ meta: (await import('./eddw')).default, geo: (await import('../generated/eddw.geo.json')).default as unknown as AirportGeo }) },
];

const cache = new Map<string, Airport>();
export async function loadAirport(icao: string): Promise<Airport> {
  const c = cache.get(icao);
  if (c) return c;
  const e = AIRPORTS.find(a => a.icao === icao);
  if (!e) throw new Error(`unknown airport ${icao}`);
  const { meta, geo } = await e.load();
  const ap = new Airport(meta, geo);
  cache.set(icao, ap);
  return ap;
}
